<template>
	<ConsoleEventArg
		:renderAs="componentName"
		:serialized="serialized"
		:value="value"
		:root="root"
		:insidePreview="insidePreview"
		:class="{'break-all': wrap}"
		:wrap="wrap"
	>
		<slot />
	</ConsoleEventArg>
</template>
<script>
export default {
	name: 'ArgValue',
	props: {
		serialized: Object,
		value: {
			validator() {
				return true // value could be of any type
			},
		},
		root: Boolean,
		insidePreview: Boolean,
		wrap: Boolean,
	},
	computed: {
		componentName() {
			const value = this.value

			if (value === null || ['number', 'boolean', 'undefined'].includes(typeof value)) {
				return 'ArgSimple'
			}
			if (typeof value === 'string') {
				return 'ArgString'
			}
			if (Array.isArray(value)) {
				return 'ArgArray'
			}
			if (typeof value === 'object') {
				if (Object.prototype.hasOwnProperty.call(value, 'constructor')) {
					return 'ArgClass'
				}
				if (Object.prototype.hasOwnProperty.call(value, '@t')) {
					switch (value['@t']) {
						case '[[Date]]':
							return 'ArgDate'
						case 'Arithmetic':
							return 'ArgArithmetic'
						case 'HTMLElement':
							return 'ArgHtml'
						case '[[Error]]':
							return 'ArgError'
						case '[[RegExp]]':
							return 'ArgRegex'
						case 'Function':
							return 'ArgFunction'
						case '[[Set]]':
							return 'ArgSet'
						case 'Symbol':
							return 'ArgSymbol'
						case '[[Map]]':
							return 'ArgMap'
						case '[[TypedArray]]':
							return 'ArgTypedArray'
						case '[[undefined]]':
							return 'ArgUndefined'
						case '[[Vue]]':
							return 'ArgVue'
						case '[[React]]':
							return 'ArgReact'
						default:
							return 'ArgSimple'
					}
				}
				if (Object.prototype.hasOwnProperty.call(value, '@r')) {
					return 'ArgRef'
				}
				return 'ArgObject'
			}
			return 'ArgSimple'
		},
	},
}
</script>
